export const summaryClauses = {
  touristEvent: [
    {
      id: "dataProcessingConsent",
      text: "Wyrażam zgodę na przetwarzanie moich danych osobowych w celu organizacji wycieczki. (wymagane)",
      required: true,
    },
    {
      id: "privacyPolicyAck",
      text: (
        <>
          Zapoznawszy się z polityką prywatności Stowarzyszenia Tęczowa Drużyna,
          oświadczam, że jest ona mi znana. (wymagane)
          <a
            href="https://drive.google.com/file/d/1igdn25xn3P4JnbHtAJDJGYvtz_4T9e7J/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            [LINK]
          </a>{" "}
        </>
      ),
      required: true,
    },
    {
      id: "tourRegulationsAck",
      text: (
        <>
          Zapoznawszy się z Ogólnymi Warunkami Imprez Turystycznych
          Stowarzyszenia Tęczowa Drużyna, oświadczam, że są mi znane. (wymagane)
          <a
            href="https://drive.google.com/file/d/1cZ6gSSpeJfk7HBpyYiF_t2b3SPnE5dTv/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
          >
            [LINK]
          </a>{" "}
        </>
      ),
      required: true,
    },
    {
      id: "insuranceConditionsAck",
      text: (
        <>
          Oświadczam za siebie i za inne osoby uczestniczące w imprezie
          turystycznej, w imieniu których dokonuję płatności za imprezę
          turystyczną, że przed zawarciem umowy uczestnictwa w imprezie
          turystycznej otrzymałem/am Ogólne Warunki Ubezpieczenia Wyjazdów
          Turystycznych 'Ubezpieczenia w podróży' zawarte w uchwale Zarządu
          Compensa TU S.A. nr 01/07/2024 z dnia 01 lipca 2024 r. oraz aneksem nr
          1 wraz z informacją o produkcie oraz Ogólne Warunki Ubezpieczenia
          Kosztów Rezygnacji z uczestnictwa w imprezie turystycznej lub
          wcześniejszego powrotu do RP, kosztów anulowania biletu lub kosztów
          anulowania noclegu zawarte w uchwale Zarządu Compensa TU S.A. nr
          01/07/2024 z dnia 01 lipca 2024 oraz aneksem nr 1 wraz z informacją o
          produkcie, stanowiące załącznik do niniejszej umowy. (wymagane)
          <a
            href="https://drive.google.com/drive/folders/1FV3-84Srg6eDLNAFqfyOP-8xBrqz3IoC"
            target="_blank"
            rel="noopener noreferrer"
          >
            [LINK]
          </a>{" "}
        </>
      ),
      required: true,
    },
    {
      id: "emailAgreementConsent",
      text: (
        <strong>
          Wyrażam zgodę na przesłanie umowy o udział w imprezie turystycznej na podany adres email.
        </strong>
      ),
      required: false,
    },
    {
      id: "newsletterConsent",
      text:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych w celu informowania mnie o działalności Stowarzyszenia Tęczowa Drużyna w formie newslettera.",
      required: false,
    },
  ],
  nonTouristEvent: [
    {
      id: "dataProcessingConsent",
      text: "Wyrażam zgodę na przetwarzanie moich danych osobowych w celu organizacji wycieczki. (wymagane)",
      required: true,
    },
    {
      id: "privacyPolicyAck",
      text: (
        <>
          Zapoznawszy się z polityką prywatności Stowarzyszenia Tęczowa Drużyna,
          oświadczam, że jest ona mi znana. (wymagane)
          <a
            href="https://drive.google.com/file/d/1igdn25xn3P4JnbHtAJDJGYvtz_4T9e7J/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            [LINK]
          </a>{" "}
        </>
      ),
      required: true,
    },
    {
      id: "eventRegulationsAck",
      text: (
        <>
          Zapoznawszy się z Regulaminem wydarzeń Stowarzyszenia Tęczowa Drużyna, oświadczam, że jest on mi znany. (wymagane)
          <a
            href="https://drive.google.com/file/d/11WN39dZGpda0AJDAmqMsbf1CIj5_SN0j/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
          >
            [LINK]
          </a>{" "}
        </>
      ),
      required: true,
    },
    {
      id: "newsletterConsent",
      text:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych w celu informowania mnie o działalności Stowarzyszenia Tęczowa Drużyna w formie newslettera.",
      required: false,
    },
  ],
};
